import { render, staticRenderFns } from "./inforequest-form.vue?vue&type=template&id=3f3b3a38&scoped=true&"
import script from "./inforequest-form.vue?vue&type=script&lang=js&"
export * from "./inforequest-form.vue?vue&type=script&lang=js&"
import style0 from "./inforequest-form.vue?vue&type=style&index=0&id=3f3b3a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3b3a38",
  null
  
)

export default component.exports